import { Button } from '@material-ui/core';
import styled from 'styled-components';

export const Action = styled(Button)<{ disabled?: boolean }>`
  border-radius: 6px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  padding-top: 13px;
  padding-bottom: 12px;
  text-transform: none;
`;

export const SubmitAction = styled(Action)<{ disabled?: boolean; black?: boolean }>`
  background-color: ${props => {
  if (props.disabled && props.black) {
      return '#0005'
    }

    if (props.black) {
      return '#000';
    }
    return props.disabled ? 'rgba(34, 90, 145, 0.5)' : 'rgba(34, 90, 145, 1)';
  }} !important;
  color: #fff !important;
`;

export const CancelAction = styled(Action)<{ disabled?: boolean }>`
  background: rgba(217, 217, 217, 1);
  color: rgba(117, 117, 117, 1);
`;
